// Add condition for all subsections - it is 'true' if at least one field should be displayed,
// else subsection should be hidden
const forgeConditionAndAddField = (ss, q) => {
  if ((!q.condition || q.condition === null) && !ss.hasOwnCondition) {
    ss.condition = null;
    return ss.fields.push({...q, parentLabel: ss.parentLabel ? `${ss.parentLabel} - ${ss.label}` : ss.label})
  }

  if (ss.condition && ss.condition !== null && q.condition) {
    ss.condition += ` || (${q.condition})`
  } else if (!ss.condition && ss.condition !== null && q.condition) {
    ss.condition = q.condition
  }

  return ss.fields.push({...q, parentLabel: ss.parentLabel ? `${ss.parentLabel} - ${ss.label}` : ss.label})
}

// The same as forgeConditionAndAddField, just for subsubsections
const forgeConditionAndAddFieldSubsubsection = (ss, q, sss) => {
  // If parent subsection had condition, 'spread' it to all questions
  if (sss.hasOwnCondition) {
    if (q.condition) {
      q.condition += `&& (${sss.condition})`
      q.conditions = [...q.conditions, ...sss.conditions];
    } else {
      q.condition = `(${sss.condition})`
      q.conditions = sss.conditions
    }
  }

  if ((!q.condition || q.condition === null) && !sss.hasOwnCondition) {
    sss.condition = null;
    return ss.fields.push({...q, level: 1, parentLabel: sss.parentLabel ? `${sss.parentLabel} - ${sss.label}` : ss.label})
  }

  if (sss.condition && sss.condition !== null && q.condition) {
    sss.condition += ` || (${q.condition})`
  } else if (!sss.condition && q.condition) {
    sss.condition = `(${q.condition})`;
    sss.conditions = q.conditions
  }

  return ss.fields.push({...q, level: 1, parentLabel: sss.parentLabel ? `${sss.parentLabel} - ${sss.label}` : ss.label})
}

// Map all fields and return an array of questions grouped by subsections
export const getSubsectionsAndQuestions = fields => {
  let res = [];
  let subsections = [];
  let subsubsections = [];

  fields.map(q => {
    // Handle fields with 'subsection' type ("containers" for questions)
    if (q.type === 'subsection') {
      const isSubSubSection = subsections.find(ss => ss.key === q.parent);

      // Handle subsubsections
      if (isSubSubSection) {
        const index = res.reduce((acc, ss, i) => ss.key === q.parent ? i : acc, undefined);

        res[index].fields.push({...q, hasOwnCondition: !!q.condition, parentLabel: res[index].label});
        return subsubsections.push(q);
      } else {
        // Handle subsections
        res.push({...q, hasOwnCondition: !!q.condition, fields: []});
        return subsections.push(q);
      }
    }

    // Handle questions

    // If question is in subsection, add it to parent's (subsection) fields array,
    // and if question has condition, add that condition to parent's condition
    if (subsections.find(ss => ss.key === q.parent)) {
      return res.find(ss => ss.key === q.parent ? forgeConditionAndAddField(ss, q) : null);
    } else if (subsubsections.find(sss => sss.key === q.parent)) {
      // The same if question is in subsubsection
      const parentSubsection = res.find(ss => ss.fields.find(sss => sss.key === q.parent));
      const subsubsection = parentSubsection.fields.find(sss => sss.key === q.parent)

      return forgeConditionAndAddFieldSubsubsection(parentSubsection, q, subsubsection);

    // Questions without a parent should be grouped in a special subsections - orphanages.
    // In some cases (probably a bug with questions) parent field is the same as key
    // This fixes it, and can be removed if concluded that it is not needed
    } else if (!q.parent || q.parent === q.key.split('_')[0] || q.parent === q.key) {
      // Check if the last question was na orphan - there should be an orphanage with
      // key of the previous question
      let orphanage = res.find(ss => ss.key === 'orphanage' + (q.order - 1));

      // If there isn't an imminent preceding orphanage, create one with the order
      // of the question
      if (!orphanage) {
        // Container for fields that aren't in a subsection.
        orphanage = {
          key: 'orphanage' + q.order,
          type: 'orphanage',
          order: q.order,
          fields: [],
        };

        res.push(orphanage)
      }

      // Update key and order of orphanage to follow order of the last question
      orphanage.key = 'orphanage' + q.order;
      orphanage.order = q.order;

      return res.find(ss => ss.key === 'orphanage' + q.order).fields.push(q)
    }

    return res;
  })

  return res;
}



// WEBPACK FOOTER //
// ./src/components/JobSection/constants.js